// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Libraries

// Components
import BTextArea from 'ui/blocks/TextArea'

// Shared

/**
 * Input with icon prepending
 *
 * @example
 *   <TextArea field={field} />
 */
export default class Input extends Component {
  static displayName = 'TextArea'

  static propTypes = {
    field: PropTypes.object,
    size: PropTypes.oneOf(['sm', 'md', 'lg'])
  }

  static defaultProps = {
    size: 'md'
  }

  render () {
    const { field, size, ...otherProps } = this.props

    // `value` prop on `textarea` should not be null
    field.value = field.value || ''

    // Remove various props that are not valid for a <textarea> DOM element.
    // Most of them come from withTranslation().
    delete otherProps.onInitialize
    delete otherProps.noMargin
    delete otherProps.i18n
    delete otherProps.tOrEmptyString
    delete otherProps.tOrLoadingBar
    delete otherProps.Trans
    delete otherProps.tReady
    delete otherProps.footerMode
    delete otherProps.errorKey

    return (
      <BTextArea size={size} {...field} {...otherProps} />
    )
  }
}
